import "./RoomUnassignOption.css";

export default function RoomUnassignOption({ disabled, busy, onClick, t }) {
  return (
    <button
      type="button"
      className="rdp-pickerOption rdp-pickerOption--unassign"
      aria-label={t("Unassign room")}
      disabled={disabled || busy}
      onClick={onClick}
    >
      <span className="rdp-pickerOptionTitle">{busy ? t("Saving...") : t("Unassign room")}</span>
      <span className="rdp-pickerOptionMeta">{t("Keep the room category and leave the room number unassigned.")}</span>
    </button>
  );
}
